export enum TypeGlobalEnum {
    SAVE_USER = "SAVE_USER",
    SAVE_ID = "SAVE_ID",
    SAVE_STATE = "SAVE_STATE",
    RESTART = "RESTART",
}